var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L5 20L5 7C5 6.45 4.55 6 4 6C3.45 6 3 6.45 3 7L3 20C3 21.1 3.9 22 5 22L15 22C15.55 22 16 21.55 16 21C16 20.45 15.55 20 15 20ZM20 16L20 4C20 2.9 19.1 2 18 2L9 2C7.9 2 7 2.9 7 4L7 16C7 17.1 7.9 18 9 18L18 18C19.1 18 20 17.1 20 16ZM18 16L9 16L9 4L18 4L18 16Z",
    fill: "#0C55B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.dfc4dc32bbb35940cad50f9287e1ba26.svg";
export { ForwardRef as ReactComponent };